<template>
  <div class="widget__content-center widget__content-center--flex">
    <div class="widget__header-text">
      <p v-if="isZoneTotal">
        Showing the average dwell time throughout the event in the Zone: <br />
        <span class="widget-message__yellow">{{ zone?.title }}</span>
      </p>
      <p v-else>
        Showing the average <span>visitor</span> dwell time for the entire event duration across the
        site.
      </p>
    </div>

    <WidgetTime :time="widgetTime" />

    <div class="dwell__time-text">
      Across
      <span class="widget-message__yellow">{{
        isZoneTotal ? formatNumber(zoneTotal?.visits, 0) : formatNumber(siteTotal.visits, 0)
      }}</span>
      Visitors
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import WidgetTime from '../WidgetTime.vue';
import type { WidgetTypeEngagedVisitorDwell, WidgetFilter, WidgetSetting } from '@/types/Widget';
import { formatNumber } from '@/utils/formatNumbers';

const props = defineProps<{
  widget: WidgetTypeEngagedVisitorDwell;
  area?: WidgetFilter;
  zone?: WidgetSetting;
}>();

const isZoneTotal = computed(() => {
  return props.area?.name === 'Zone' && props.zone;
});

const widgetTime = computed(() => {
  if (props.zone?.id) {
    const data = props.widget.data['Zone'][props.zone.id]['Total'];
    const dwellTime = data['Dwell'];
    return dwellTime;
  } else {
    const data = props.widget.data['Site']['Total'];
    const dwellTime = data['Dwell'];
    return dwellTime;
  }
});

const siteTotal = computed(() => {
  let visits = 0;

  const data = props.widget.data['Site']['Total'];

  if (data['Visitors']) {
    visits = data['Visitors'];
  }

  return {
    visits,
  };
});

const zoneTotal = computed(() => {
  let visits = 0;

  if (props.zone?.id) {
    const data = props.widget.data['Zone'][props.zone.id]['Total'];

    if (data['Visitors']) {
      visits = data['Visitors'];
    }
  }

  return {
    visits,
  };
});
</script>
